import pricingContextModuleHelpers from "@vp/pricing-context-module/helpers";
import { useEffect, useState } from "react";

import { productPricingService } from "../services/productPricingService";
import { useProductStore } from "../store/productPriceDetails.store";
import {
  getPricingContext,
  getPricingContextVatInclusivity,
  isPricingContextInitialized,
} from "../util/pricing-context";

const usePricingContextInitialization = (
  tenant: string,
  locale: string,
  developmentMode?: boolean,
) => {
  const [pricingContextInitialized, setPricingContextInitialized] = useState(false);
  const [vatIncl, setVatInclLocal] = useState<boolean>(() => Boolean(getPricingContextVatInclusivity()));

  const setPricingContext = useProductStore((state) => state.setPricingContext);
  const setVatIncl = useProductStore((state) => state.setVatIncl); //this will be deprecated once moved to PriceDisplayV2

  useEffect(() => {
    const handleInitializedEvent = () => {
      const initialized = isPricingContextInitialized(developmentMode);
      setPricingContextInitialized(initialized);
      if (initialized) {
        setPricingContext(getPricingContext());
        const isVatInclusive = getPricingContextVatInclusivity();
        setVatIncl(isVatInclusive);
        setVatInclLocal(Boolean(isVatInclusive));
        productPricingService.pricingContext = getPricingContext();
        productPricingService.vatIncl = isVatInclusive;
      }
    };

    const updateVatInclusivity = () => {
      const isVatInclusive = getPricingContextVatInclusivity();
      setVatIncl(isVatInclusive);
      setVatInclLocal(Boolean(isVatInclusive));
      productPricingService.vatIncl = isVatInclusive;
    };

    const updatePricingContext = () => {
      setPricingContext(getPricingContext());
      productPricingService.pricingContext = getPricingContext();
    };
    /** init event listener to be added only if pricing context was not initialized yet */
    if (isPricingContextInitialized(developmentMode)) {
      handleInitializedEvent();
    } else {
      document.addEventListener(
        pricingContextModuleHelpers.EVENTS.INITIALIZED_EVENT,
        handleInitializedEvent,
      );
    }
    document.addEventListener(
      pricingContextModuleHelpers.EVENTS.VAT_INCLUSIVITY_CHANGE_EVENT,
      updateVatInclusivity,
    );
    document.addEventListener(
      pricingContextModuleHelpers.EVENTS.CONTEXT_CHANGE_EVENT,
      updatePricingContext,
    );

    return () => {
      if (!isPricingContextInitialized(developmentMode)) {
        document.removeEventListener(
          pricingContextModuleHelpers.EVENTS.INITIALIZED_EVENT,
          handleInitializedEvent,
        );
      }
      document.removeEventListener(
        pricingContextModuleHelpers.EVENTS.VAT_INCLUSIVITY_CHANGE_EVENT,
        updateVatInclusivity,
      );
      document.removeEventListener(
        pricingContextModuleHelpers.EVENTS.CONTEXT_CHANGE_EVENT,
        updatePricingContext,
      );
    };
  }, [tenant, locale, setPricingContext, setVatIncl, developmentMode]);

  return { pricingContextInitialized, vatIncl };
};

export default usePricingContextInitialization;
